import React from "react"
import { SRLWrapper } from "simple-react-lightbox";

const ImageCollection = (data) => {
    const imageCollection = data.linkedItem.elements
    const images = imageCollection.images.value
    const srlOptions = {
        buttons: {
            showAutoplayButton: false,
            showThumbnailsButton: false,
            showDownloadButton: false,
            showFullscreenButton: true,
        },
        thumbnails: {
            thumbnailsSize: ['100px', '100px']
        }
    }

    return (
        <div className="image-collection">
        {imageCollection.title && 
            <h2>{imageCollection.title.value}</h2>
        }
        {imageCollection.introduction && 
            <div
                dangerouslySetInnerHTML={{
                __html:
                imageCollection.introduction.value,
                }}
            />
        }
        <SRLWrapper options={srlOptions}>
            {images.map((e) => {
            return (
                <a href={e.url}><img src={e.url} alt={e.description} className="image-collection--thumb" /></a>
            )
            })}
        </SRLWrapper>
        </div>
    );
}
  
  export default ImageCollection